import { CompareMode } from '../types/Report';

export const COMPARE_MODE_OPTIONS: { value: CompareMode; label: string }[] = [
  { value: 'none', label: 'Comparison None' },
  { value: 'yoy', label: 'Year-over-Year' },
  { value: 'previous', label: 'Previous Period' },
];

export const COMPARISON_NONE_MOVERS_MESSAGE =
  'Comparison None shows this date range only. Choose Year-over-Year or Previous Period to see movers.';

export function parse_compare_mode(value: string | null | undefined): CompareMode {
  if (value === 'none' || value === 'yoy' || value === 'previous') {
    return value;
  }
  return 'yoy';
}

/**
 * A prior period is shown unless the caller explicitly chose Comparison None.
 * An omitted mode stays on the year-over-year default.
 */
export function has_active_comparison(compare_mode?: CompareMode | null): boolean {
  return compare_mode !== 'none';
}

export function compare_mode_label(compare_mode?: CompareMode | null): string {
  const match = COMPARE_MODE_OPTIONS.find((option) => option.value === compare_mode);
  return match?.label ?? 'Year-over-Year';
}
